import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ConfigurationResolver } from './resolver/configuration.resolver';
const routes: Routes = [
  {
    path: '', loadChildren: () => import('./core/core.module').then(m => m.CoreModule), resolve: { data: ConfigurationResolver }
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
